import React                     from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getRoute, redirects }   from 'pursuit/routes/routes';

export default function ExternalRedirects()
{
    const location = useLocation();

    if (redirects[location.pathname]) {
        window.location.href = redirects[location.pathname];
        return null;
    }

    return <Navigate to={getRoute('home')} />;
}
